import { render, staticRenderFns } from "./ComplianceService.vue?vue&type=template&id=2d6e3021&scoped=true&"
import script from "./ComplianceService.vue?vue&type=script&lang=js&"
export * from "./ComplianceService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6e3021",
  null
  
)

export default component.exports